import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    n: "S/01",
    title: "Profile Evaluation & Course Selection",
    desc: "Deep-dive academic audit, career alignment, and shortlist of 6-8 best-fit programs based on your goals.",
    tags: ["Assessment", "Shortlisting", "Career Match"],
  },
  {
    n: "S/02",
    title: "SOP & LOR Editorial",
    desc: "Story-driven statements of purpose and letters of recommendation crafted by published editors.",
    tags: ["Storytelling", "Editing", "Recommendations"],
  },
  {
    n: "S/03",
    title: "Visa Interview & Financial Docs",
    desc: "Consulate-grade mock interviews, financial evidence sheets, and sponsor letter engineering.",
    tags: ["Mock Interview", "Documentation", "Compliance"],
  },
  {
    n: "S/04",
    title: "Scholarships & IELTS / TOEFL",
    desc: "Merit and need-based scholarship matching plus band-9 focused test prep with our in-house coaches.",
    tags: ["Funding", "Test Prep", "Coaching"],
  },
];

export default function Services() {
  return (
    <section
      id="services"
      className="relative py-24 md:py-32 bg-[#F5F7FA]"
      data-testid="services-section"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-14 md:mb-20">
          <div className="md:col-span-4">
            <span className="section-label">CH · 02 / Services</span>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-display text-[#0a192f] text-4xl sm:text-5xl md:text-6xl tracking-[-0.025em] leading-[0.98]">
              Four disciplines. One{" "}
              <span className="italic font-normal">departure gate.</span>
            </h2>
            <p className="text-[#0a192f]/60 mt-6 max-w-xl font-body">
              We compress the entire study-abroad journey into four rigorously
              designed practices — each led by senior specialists, never
              outsourced.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {SERVICES.map((s, i) => (
            <motion.a
              key={i}
              href="#contact"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.7,
                delay: i * 0.08,
                ease: [0.22, 1, 0.36, 1],
              }}
              whileHover={{ y: -6 }}
              className="group relative block bg-white p-8 md:p-10 border border-[#0a192f]/10 hover:border-[#0a192f]/25 transition-colors"
              data-testid={`service-card-${i}`}
            >
              <div className="flex items-start justify-between mb-10">
                <span className="font-mono-tech text-[11px] text-[#0a192f]/50">
                  {s.n}
                </span>
                <div className="w-9 h-9 rounded-full border border-[#0a192f]/15 flex items-center justify-center group-hover:bg-[#0a192f] group-hover:border-[#0a192f] transition-colors">
                  <ArrowUpRight
                    size={16}
                    className="text-[#0a192f] group-hover:text-white transition-colors"
                  />
                </div>
              </div>
              <h3 className="font-display text-2xl md:text-3xl text-[#0a192f] tracking-tight leading-[1.05] mb-4 max-w-md">
                {s.title}
              </h3>
              <p className="text-[#0a192f]/65 leading-relaxed font-body mb-8 max-w-lg">
                {s.desc}
              </p>
              <div className="flex flex-wrap gap-2 pt-6 border-t border-[#0a192f]/10">
                {s.tags.map((t) => (
                  <span
                    key={t}
                    className="font-mono-tech text-[10px] text-[#0a192f]/60 tracking-wide"
                  >
                    · {t}
                  </span>
                ))}
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
